// extracted by mini-css-extract-plugin
export default {"pageContentContainer":"styles_pageContentContainer__lW3sH","topText":"styles_topText__Ff1Uk","bottomText":"styles_bottomText__je-7L","bold":"styles_bold__ymZio"};